export default class DeadZoneMetric {
    map;
    rg;
    d;
    val;
    constructor(model) {
        this.map = model.map;
        this.val = model.val.toFixed(2);
        this.d = model.d;
        this.rg = model.rg;
    }
}
